(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header =
        this.closest('.section-header') ||
        document.querySelector('.section-header');

      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerIsDisabled = this.getAttribute('data-sticky-type') === 'none';

      if (this.headerIsDisabled) return;

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('load', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.reveal();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('load', this.onResizeHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;

      const headerHeight = this.header.offsetHeight || this.offsetHeight || 0;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--fhf-header-height', `${headerHeight}px`);
      document.body.style.setProperty('--fhf-header-height', `${headerHeight}px`);

      this.headerHeight = headerHeight;
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const triggerPoint = this.headerHeight || this.header.offsetHeight || 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > triggerPoint) {
        this.header.classList.add('scrolled-past-header');

        if (scrollTop > this.currentScrollTop) {
          if (!this.preventHide) {
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop < this.currentScrollTop) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      document.body.classList.add('fhf-header-is-fixed');

      this.header.classList.add(
        'shopify-section-header-sticky',
        'shopify-section-header-hidden',
        'fhf-header-sticky-active',
        'fhf-header-hidden'
      );

      this.header.classList.remove(
        'animate',
        'fhf-header-visible'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      document.body.classList.add('fhf-header-is-fixed');

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate',
        'fhf-header-sticky-active',
        'fhf-header-visible'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'fhf-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        this.reveal();
        return;
      }

      document.body.classList.remove('fhf-header-is-fixed');

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'fhf-header-sticky-active',
        'fhf-header-hidden',
        'fhf-header-visible'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      if (!this.disclosures) return;

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videocarousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.video-carousel-wrapper');

  wrappers.forEach(wrapper => {
    const sectionEl = document.getElementById('video'); // anchor target
    const track = wrapper.querySelector('.video-carousel-track');
    const slides = Array.from(track.querySelectorAll('.video-carousel-slide'));
    const prev = wrapper.querySelector('.video-carousel-arrow.prev');
    const next = wrapper.querySelector('.video-carousel-arrow.next');
    const dots = Array.from(wrapper.querySelectorAll('.video-carousel-dots .dot'));
    let index = 0;

    function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

    function updateCarousel() {
      const slide = slides[0];
      if (!slide) return;
      // slide width + 4% (2% + 2% margins) to match CSS
      const slideWidth = slide.offsetWidth + (slide.offsetWidth * 0.04);
      const offset = slideWidth * index;
      track.style.transform = `translateX(-${offset}px)`;
      if (dots.length) {
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }
    }

    function setHashFromIndex(i) {
      // Keep the hash pointing to the real element id so native scroll happens
      const newHash = `#video?slide=${i + 1}`;
      if (window.location.hash !== newHash) {
        window.location.hash = newHash; // triggers page scroll
      } else {
        // If already correct, ensure the section is in view anyway
        sectionEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function goTo(i, { syncHash = true, scroll = true } = {}) {
      index = clamp(i, 0, slides.length - 1);
      updateCarousel();
      if (syncHash) setHashFromIndex(index);
      else if (scroll) sectionEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Parse #video?slide=N or plain #video
    function parseHashForIndex() {
      const hash = window.location.hash || '';
      if (!hash.toLowerCase().startsWith('#video')) return null;

      const q = hash.split('?')[1];
      if (q) {
        const params = new URLSearchParams(q);
        const s = params.get('slide');
        if (s) {
          const i = parseInt(s, 10);
          if (!Number.isNaN(i)) return i - 1;
        }
      }
      // plain #video -> default to first slide
      return 0;
    }

    // Initialize: honor hash and scroll to section
    const startFrom = parseHashForIndex();
    if (typeof startFrom === 'number') {
      goTo(startFrom, { syncHash: false, scroll: true });
    } else {
      updateCarousel();
    }

    // Keep in sync if hash changes later (e.g., user edits URL)
    window.addEventListener('hashchange', () => {
      const hIndex = parseHashForIndex();
      if (typeof hIndex === 'number') {
        goTo(hIndex, { syncHash: false, scroll: true });
      }
    });

    // Controls (only if present)
    if (next) next.addEventListener('click', () => { if (index < slides.length - 1) goTo(index + 1); });
    if (prev) prev.addEventListener('click', () => { if (index > 0) goTo(index - 1); });

    if (dots.length) {
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const i = parseInt(dot.getAttribute('data-slide'), 10) || 0;
          goTo(i);
        });
      });
    }

    window.addEventListener('resize', updateCarousel);

    // --- Play/Pause Overlay for uploaded <video> only ---
    slides.forEach(slide => {
      const video = slide.querySelector('video');
      const btn = slide.querySelector('.play-overlay');
      if (!video || !btn) return;

      btn.addEventListener('click', e => {
        e.preventDefault();
        if (video.paused) {
          video.play();
          btn.classList.add('playing');
        } else {
          video.pause();
          btn.classList.remove('playing');
        }
      });

      slide.addEventListener('mouseenter', () => btn.style.opacity = '1');
      slide.addEventListener('mouseleave', () => { if (!video.paused) btn.style.opacity = '0'; });
      video.addEventListener('play', () => { btn.classList.add('playing'); btn.style.opacity = '0'; });
      video.addEventListener('pause', () => { btn.classList.remove('playing'); btn.style.opacity = '1'; });
      video.addEventListener('ended', () => { btn.classList.remove('playing'); btn.style.opacity = '1'; });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
